var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-max-content px-1 mb-1"},[_c('span',{staticClass:"badge bg-theme",on:{"click":_vm.remove}},[_vm._v(_vm._s(_vm.pesquisa.valor)+" "),_c('i',{staticClass:"fal fa-times ms-1"})])])}
var staticRenderFns = []

export { render, staticRenderFns }